import { FC } from "react";
import { CommitmentUtilizationWidgetChartBaseSelect } from "../../../../adding-widget/widget-create/widget-setups/commitment-utilization/components/sidebar/components/configurations/visualization/components/CommitmentUtilizationWidgetChartBaseSelect";
import { CommitmentUtilizationWidgetVisualizationUtilization } from "../../../../adding-widget/widget-create/widget-setups/commitment-utilization/components/sidebar/components/configurations/visualization/components/CommitmentUtilizationWidgetVisualizationUtilization";
import { CommitmentUtilizationWidgetVisualizationCommitment } from "../../../../adding-widget/widget-create/widget-setups/commitment-utilization/components/sidebar/components/configurations/visualization/components/CommitmentUtilizationWidgetVisualizationCommitment";
import { CommitmentUtilizationWidgetVisualizationNetSavings } from "../../../../adding-widget/widget-create/widget-setups/commitment-utilization/components/sidebar/components/configurations/visualization/components/CommitmentUtilizationWidgetVisualizationNetSavings";
import {
  ChartType,
  WidgetCommitmentsUtilizationVisualization,
} from "@/services/cloudchipr.api";
import { CommitmentUtilizationWidgetScaleSelect } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/commitment-utilization/components/sidebar/components/configurations/visualization/components/CommitmentUtilizationWidgetScaleSelect";
import { CommitmentUtilizationWidgetVisualizationShowDataLabels } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/commitment-utilization/components/sidebar/components/configurations/visualization/components/CommitmentUtilizationWidgetVisualizationShowDataLabels";
import { CommitmentUtilizationWidgetVisualizationShowLegends } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/commitment-utilization/components/sidebar/components/configurations/visualization/components/CommitmentUtilizationWidgetVisualizationShowLegends";

export const commitmentUtilizationVisualizationDetailsByChartType = new Map<
  ChartType,
  (keyof WidgetCommitmentsUtilizationVisualization)[]
>([
  [
    "stacked_column",
    ["scale", "chart_base_type", "show_data_labels", "show_legends"],
  ],
  [
    "horizontal_stack_bar",
    ["scale", "chart_base_type", "show_data_labels", "show_legends"],
  ],
  ["column", ["scale", "chart_base_type", "show_data_labels", "show_legends"]],
  ["table", ["utilization", "commitment", "net_savings"]],
]);

export const commitmentUtilizationVisualizationDetailsComponentByType = new Map<
  keyof WidgetCommitmentsUtilizationVisualization,
  FC
>([
  ["chart_base_type", CommitmentUtilizationWidgetChartBaseSelect],
  ["utilization", CommitmentUtilizationWidgetVisualizationUtilization],
  ["commitment", CommitmentUtilizationWidgetVisualizationCommitment],
  ["net_savings", CommitmentUtilizationWidgetVisualizationNetSavings],
  ["scale", CommitmentUtilizationWidgetScaleSelect],
  ["show_data_labels", CommitmentUtilizationWidgetVisualizationShowDataLabels],
  ["show_legends", CommitmentUtilizationWidgetVisualizationShowLegends],
]);
